import Vue from "vue";

Vue.filter('time', (seconds)=>{
  let dt = new Date(null);
  let str = '';
  dt.setSeconds(seconds);
  let h = dt.getHours() - 1;
  let m = dt.getMinutes();
  let s = dt.getSeconds();
  if(h>0) str+= h+":";
  str+= (m<10 && h>0) ? '0'+m : m;
  str+= ':';
  str+= (s<10) ? '0'+s : s;
  return str;
});


Vue.filter('maxlen', (string, maxLength)=>{
  let str = string || '';
  if(str.length > maxLength){
    str = str.substr(0, maxLength)+"...";
  }
  return str;
});

Vue.filter('prettyInt', (number) => {
  return number.toLocaleString();
});



// WEBPACK FOOTER //
// ./src/services/VueFilters.js